import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { BookButton, WhatsAppButton, CallButton, DirectionsButton } from "../components/CTAButtons";
import { ZORBA, BRAND } from "../data/content";
import { breadcrumbSchema, daySpaSchema, multiGraph } from "../components/Schema";

export default function Contact({ onBook }) {
  const crumbs = [{ label: "Home", href: "/" }, { label: "Contact" }];
  return (
    <>
      <Seo
        title="Contact Spa Near Me Bhubaneswar"
        description="Reach us for enquiries about spa, massage and wellness experiences in Bhubaneswar — via WhatsApp, phone or our short enquiry form."
        path="/contact/"
        jsonLd={multiGraph(daySpaSchema(), breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow">{BRAND.short}</p>
        <h1>Contact us.</h1>
        <p className="large-copy">
          Send a short enquiry and we'll connect you with our featured partner — {ZORBA.name}. For general
          platform questions, email us at <a href={`mailto:${BRAND.email}`} data-testid="contact-email">{BRAND.email}</a>.
        </p>
      </section>
      <section className="section-pad narrow">
        <div className="contact-grid">
          <article>
            <h2>Preferred: a short WhatsApp conversation</h2>
            <p className="large-copy">
              The quickest route to a confirmed appointment is a short WhatsApp message with your service,
              preferred time and number of guests. Our featured partner will take it from there.
            </p>
            <div className="actions-row">
              <WhatsAppButton label="WhatsApp our partner" source="contact_page" testid="contact-whatsapp-cta" />
              <CallButton source="contact_page" testid="contact-call-cta" />
              <BookButton onBook={onBook} label="Open enquiry form" testid="contact-book-cta" />
              <DirectionsButton testid="contact-directions-cta" />
            </div>
          </article>
          <aside className="info-box">
            <strong>{ZORBA.name}</strong>
            <span>{ZORBA.city}, {ZORBA.state}, {ZORBA.country}</span>
            <small>{ZORBA.disclosure}</small>
            <small className="muted">Address, phone, hours and pricing are confirmed directly by the spa.</small>
          </aside>
        </div>
      </section>
    </>
  );
}
